<p-dialog
  [visible]="visible()"
  (visibleChange)="$event ? visible.set(true) : close()"
  [modal]="true"
  [closable]="!submitting()"
  [closeOnEscape]="!submitting()"
  [style]="{ width: '38rem' }"
  [draggable]="false"
  [resizable]="false"
  header="New organization"
>
  <form class="create-org-form" [formGroup]="form" (ngSubmit)="submit()">
    @if (submitError(); as error) {
      <app-error-banner [message]="error" />
    }

    <div class="field">
      <label for="org-name">Company name</label>
      <input id="org-name" pInputText type="text" formControlName="name" autocomplete="off" />
      @if (invalid('name')) {
        <span class="field-error">A company name is required.</span>
      }
    </div>

    <div class="field">
      <label for="org-admin-email">Admin email</label>
      <input
        id="org-admin-email"
        pInputText
        type="email"
        formControlName="adminEmail"
        autocomplete="off"
      />
      <span class="field-hint">Gets the invite link to claim the admin account.</span>
      @if (invalid('adminEmail')) {
        <span class="field-error">A valid email address is required.</span>
      }
    </div>

    <div class="form-row">
      <div class="field">
        <label for="org-plan">Plan</label>
        <p-select
          inputId="org-plan"
          formControlName="pricingPlanId"
          [options]="plans()"
          optionLabel="name"
          optionValue="id"
          placeholder="Select a plan"
          appendTo="body"
        ></p-select>
        @if (selectedPlanPrice(); as price) {
          <span class="field-hint">
            {{ price.perSeat | number: '1.0-2' }} {{ price.currency }} per seat,
            {{ price.period }}
          </span>
        }
        @if (invalid('pricingPlanId')) {
          <span class="field-error">Pick the plan this customer was sold.</span>
        }
      </div>

      <div class="field">
        <label for="org-billing-period">Billing period</label>
        <p-select
          inputId="org-billing-period"
          formControlName="billingPeriod"
          [options]="billingPeriods"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
        ></p-select>
      </div>

      <div class="field">
        <label for="org-seats">Seats</label>
        <p-inputnumber
          inputId="org-seats"
          formControlName="seats"
          [min]="1"
          [showButtons]="true"
        ></p-inputnumber>
        @if (invalid('seats')) {
          <span class="field-error">At least one seat.</span>
        }
      </div>
    </div>

    <div class="form-row">
      <div class="field">
        <label for="org-registration-code">Registration code (optional)</label>
        <input
          id="org-registration-code"
          pInputText
          type="text"
          formControlName="registrationCode"
          autocomplete="off"
        />
      </div>

      <div class="field">
        <label for="org-address">Address (optional)</label>
        <input
          id="org-address"
          pInputText
          type="text"
          formControlName="address"
          autocomplete="off"
        />
      </div>
    </div>

    <span class="field-hint">
      Creates the organization, a local subscription on the chosen plan and the admin invite. No
      Stripe subscription is started - the customer's own checkout replaces it later.
    </span>

    <div class="dialog-actions">
      <p-button
        label="Cancel"
        severity="secondary"
        [text]="true"
        [disabled]="submitting()"
        (click)="close()"
      ></p-button>
      <p-button
        type="submit"
        label="Create organization"
        icon="pi pi-plus"
        [loading]="submitting()"
      ></p-button>
    </div>
  </form>
</p-dialog>
